import {I18nMessage} from '@shared/api/model/i18n';
import {
  Device,
  DeviceObject,
  Equipment,
  Favourite,
  Level,
  Collector,
} from '@app/graphql-typings/graphql';
import {SiteInfo} from "@shared/services/api/access-sites.interface";

export interface Select {
  id: number;
  name: string;
}

export enum FavouriteType {
  BACNET = 'BACnet',
  SQLSERVER = 'SQL Server',
  HAYSTACK = 'Haystack',
  SMARTCONNECTOR = 'Smart Connector',
  SIEMENS = 'Siemens',
  VIRTUAL = 'Virtual'
}

export interface Status {
  error: boolean;
  message?: string;
  acknowledged?: boolean;
}


export interface FavouriteSearchTerm {
  site_id?: number;
  fav_id?: number;
  fav_ids?: number[];
  favourite_type?: FavouriteType;
  equipment_id?: number;
  canonical_equipment_id?: number;
  equipment_ids?: number[];
  metadata_name?: string;
  metadata_id?: number;
  metadata_ids?: number[]
  zone_id?: number;
  device_id?: number;
  metadata_codes?: string[];
  zone_name_id?: number;
  level_id?: number;
  system?: boolean;
  commissionable?: boolean;
}

export type FavouriteForValidationStatusResponseType = 'Incomplete' | 'Error' | 'Clash' | 'Warning' | 'Done' | 'Ready';

export type FavouriteForValidationStatusType = FavouriteForValidationStatusResponseType;

export interface FavouriteForValidationStatus {
  /* Done - This exact favourite already exists */
  /* Warning - Applies to Zone Temp and Zone Setpoints only - Another Zone Temp/Setpoint favourite
  already exists on same zone_id */
  /* Clash - Identifies duplicate Errors with a group of favourite to be created. Clashes can
  be rectified by removing the other duplicate favourite from selection for creation */
  /* Error - Favourite cannot be created because it duplicates another existing favourite. This
  cannot be rectified */
  /* Incomplete - Favourite is missing some required properties */
  type: FavouriteForValidationStatusType;
  message?: string;
  i18nMessage?: I18nMessage;
  disabled?: boolean;
}

export interface FavouriteForValidationResponseStatus extends FavouriteForValidationStatus {
  type: FavouriteForValidationStatusResponseType;
}

export interface FavouriteValidationResponse {
  favouriteStatus: FavouriteForValidationResponseStatus;
  errorDuplicates: Favourite[];
  warningDuplicates: Favourite[];
}

export interface FavouriteValidationWarning {
  message: I18nMessage,
  type: 'warning' | 'danger';
}

export interface DuplicateErrorOrClash {
  identifierEquipment: boolean;
  identifierDevice: boolean;
  zoneEquipmentMetadata: boolean;
}
